import React from 'react'

// Style //
import "./ButtonComp.css"

const ButtonComp = ({title, onClick, width, bgColor, style, disabled = false}) => {
  return (
    <button onClick={onClick} disabled={disabled} className="btn_comp" style={{
      width: `${width}`,
      backgroundColor: `${bgColor}`,
      ...style,
    }}>
            {title}
    </button>
  )
}

export default ButtonComp;